import React from "react";
import image1 from "../assests/partners/Coca-Cola.png";
import image2 from "../assests/partners/um.png";
import image3 from "../assests/partners/Arena-Media.png";
import img4 from "../assests/partners/Emirates.png";
import img5 from "../assests/partners/Ooredoo.png";
import img6 from "../assests/logo06.png";
import img7 from "../assests/logo07.png";
import img8 from "../assests/logo08.png";
import img9 from "../assests/logo09.png";
// import Head from "./Head";
import Footer from "./Footer";

const Partners = () => {
  return (
    <>
      <section className="clients">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-sm-12 wow" data-splitting>
              <h3 className="section-title">
                AGENSY PROUD IS QUALITY OF PARTNERS
              </h3>
            </div>
            <div className="col-lg-7">
              <ul>
                <li className="reveal-effect masker wow">
                  <img src={image1} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={image2} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={image3} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={img4} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={img5} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={img6} alt="Img" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Partners;
